import { Injectable } from '@angular/core';

import { createDialogServiceBase } from 'tiime-material';

import { User } from '@models/user';

import { CreateUserDialogData } from './create-user-dialog-data';
import { CreateUserDialogComponent } from './create-user-dialog.component';

@Injectable({ providedIn: 'root' })
export class CreateUserDialogService extends createDialogServiceBase<User, CreateUserDialogData>(
  CreateUserDialogComponent
) {}
